
import React, { PropsWithChildren, ReactNode, useEffect } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import './ProductTiles.css';
import { useWidthContext } from '../../providers/Width';
import ProductTile, { ProductContent } from './ProductTile';
import { CarouselSlider } from '../../importCL';

interface IProductTilesProps extends MappedComponentProperties {
    productTiles?: ProductContent[];
    metaDataOverride?: boolean;
}

const ELEMENTS_TO_EQUALIZE = [
    '.ProductTiles__title',
    '.ProductTiles__detailsContent',
    '.ProductTiles__rate',
    '.ProductTiles__modalLink',
];

export const ProductTilesEditConfig = {
    emptyLabel: 'Product Tiles',
    isEmpty: (props: PropsWithChildren<IProductTilesProps>) => {
        return !props || !props.productTiles;
    },
};

const ProductTiles = (props: PropsWithChildren<IProductTilesProps>): JSX.Element => {
    const { width } = useWidthContext();

    const productTiles = props.productTiles?.reduce((tiles: ReactNode[], product: ProductContent, i: number) => {
        tiles.push(<ProductTile key={i} product={product} isMobile={width <= 769} isMetaDataOverride={props.metaDataOverride}/>);

        return tiles;
    }, []) ?? [];

    const handleEqualizeHeights = () => {
        ELEMENTS_TO_EQUALIZE.forEach((className: string) => {
            const elements = Array.from(document.querySelectorAll(className));
            const heights = elements.map((el: any) => {
                el.style.height = ''; // reset any inline styles
                return el.offsetHeight;
            });
            const maxHeight = Math.max(...heights, 0);

            elements.forEach((el: Element) => el.setAttribute('style', `height: ${maxHeight ? maxHeight + 'px' : ''}`));
        });
    };

    useEffect(() => {
        setTimeout(() => handleEqualizeHeights(), 1);
    }, [width]);

    return (
        <div className='ProductTiles__wrapper'>
            {width <= 769 && (
                <CarouselSlider className='ProductTiles__carousel'
                    slides={productTiles}
                    hideDefaultArrows={true}
                    dots
                    properties={{
                        dotsOnTop: true,
                        peek: true,
                        slideGap: 16,
                        maxSlideWidth: 360,
                    }} />
            )}
            {width > 769 && (
                productTiles
            )}
        </div>
    );
};
export default ProductTiles;

